<template>
    <div class="video-container">
        <v-row align-items="center" justify="space-evenly" class="header">
            <v-col style="display: flex; flex-direction: column; align-items: start;">
                <v-btn @click="$emit('close-content')" variant="text" color="inherit"><img
                        src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/642712b9-7c61-4e25-87b0-5b7aefc49d67.svg"
                        alt=""></v-btn>
                <p class="submenu-title">{{ props.item.title }}</p>
            </v-col>
        </v-row>

        <div class="video-content">
            <video width="300" height="300" controls
               :src=" videobotContent.videobotContent.embeds[props.item.id].content"></video>
        </div>
    </div>
</template>

<script setup>
import { defineEmits, defineProps } from 'vue';
import { useVideobotContentStore } from '../../../../store';

defineEmits(["close-content"])
const props = defineProps(['item'])
const videobotContent = useVideobotContentStore();


</script>

<style scoped>
.video-container {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    z-index: 2;
    background: white;
}

.header {
    height: 25%;
    background-color: #BC4AFF;
}

.submenu-title {
    color: white;
    font-size: 20px;
    text-align: start;
    margin-left: 10%;
    margin-top: 10%;
}

.video-content {
    margin-top: 10%;
}
</style>